import Track from "@/utils/track";
const track = Track();

export const btn_click = (module: string, btn_name: string) => {
  const params = {
    page_name: "我的",
    previous_page_name: "无",
    domain: "我的",
    module,
    btn_name,
  };
  track.track("btn_click", params);
};

export const page_view = () => {
  const params = {
    page_name: "我的",
    previous_page_name: "无",
    domain: "我的",
  };
  track.track("$page_view", params);
};
